var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAivyicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "56px",
    viewBox: "0 0 64 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aivyicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.668258212 63.1563019 0.668258212 63.1563019 55.3250313 0 55.3250313"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "6.07920155e-05 0.556086747 34.3787384 0.556086747 34.3787384 21.5903614 6.07920155e-05 21.5903614"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "-0.000340616246 0.663228916 43.398766 0.663228916 43.398766 55.3253012 -0.000340616246 55.3253012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "-0.000340616246 0.663228916 43.398766 0.663228916 43.398766 55.3253012 -0.000340616246 55.3253012"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aivyicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9024197,52.5405494 L33.2020455,1.59066988 C32.8307738,0.954428916 32.1747469,0.650814458 31.5255323,0.669031325 L31.5241699,0.669031325 C31.2189777,0.677127711 30.9165105,0.755392771 30.6453799,0.909224096 C30.6085934,0.92946506 30.5786192,0.961175904 30.5431951,0.984115663 C30.4471413,1.04753735 30.3504063,1.10893494 30.2659334,1.19259759 C30.1487615,1.30594699 30.0438517,1.43818795 29.9552914,1.59066988 L0.254235966,52.5405494 C0.0737093557,52.8495614 -0.00531361345,53.1788145 -0.000126887496,53.497947 C0.0171670588,54.4492723 0.786278543,55.3115373 1.85785725,55.3230072 C1.86466958,55.3230072 1.87011944,55.3250313 1.87693176,55.3250313 L1.87693176,55.3250313 L22.1708477,55.3250313 L31.5255323,39.2786699 L40.8795357,55.3250313 L61.2790427,55.3250313 C62.7218931,55.3250313 63.6238449,53.777947 62.9024197,52.5405494",
    id: "Fill-1",
    fill: "#FE79A7",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 33.734940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8765714,0.556086747 C19.2574207,0.556086747 8.13153165,6.9104 1.55286947,16.5774843 L0.702691317,18.0368578 L0.253759104,18.8053398 C-0.106612885,19.4247133 -0.0616515406,20.1210024 0.253759104,20.6621108 C0.275558543,20.6985446 0.307576471,20.7275566 0.330738375,20.762641 C0.395455462,20.8577735 0.458810084,20.9535807 0.539195518,21.035894 C0.582794398,21.0790747 0.63797423,21.1107855 0.685660504,21.1505928 C0.759914846,21.2119904 0.82940056,21.2787855 0.913192157,21.329388 C0.975865546,21.3664964 1.05011989,21.3867373 1.1175619,21.4164241 C1.1993098,21.4521831 1.27560784,21.4967133 1.36348683,21.5210024 C1.43842241,21.5419181 1.52221401,21.5419181 1.60123697,21.553388 C1.69320336,21.5668819 1.78040112,21.5904964 1.87713613,21.5904964 L22.1710521,21.5904964 L34.3787384,0.649195181 C33.5510409,0.59386988 32.7185748,0.556086747 31.8765714,0.556086747",
    id: "Fill-4",
    fill: "#FFB629",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(19.755742, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1239978,55.3253012 L41.5235048,55.3253012 C42.9609053,55.3253012 43.8587697,53.7910361 43.1530129,52.5556627 L13.4356078,1.57744578 C12.7080515,0.354216867 10.9177725,0.357590361 10.1990723,1.59026506 L-0.000340616246,19.0872289 L21.1239978,55.3253012 Z",
    id: "Fill-7",
    fill: "#4264DC",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(19.755742, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1239978,55.3253012 L41.5235048,55.3253012 C42.9609053,55.3253012 43.8587697,53.7910361 43.1530129,52.5556627 L13.4356078,1.57744578 C12.7080515,0.354216867 10.9177725,0.357590361 10.1990723,1.59026506 L-0.000340616246,19.0872289 L21.1239978,55.3253012 Z",
    id: "Fill-10",
    fill: "#4264DC",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.6954201,34.4234699 L40.8799444,55.3249639 L61.2794514,55.3249639 C62.7161708,55.3249639 63.6147164,53.7906988 62.9089596,52.556 L59.7977708,47.2184578 C53.0556128,39.3150361 42.9801842,34.2912289 31.7160049,34.2912289 C30.6975624,34.2912289 29.6927444,34.3431807 28.6954201,34.4234699",
    id: "Fill-13",
    fill: "#00CEC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAivyicon);
export default __webpack_public_path__ + "static/media/aivyicon.4bc466c5045a0b350d5ca218822f1667.svg";
export { ForwardRef as ReactComponent };